export default "__VITE_ASSET__nTyp4aGH__"